import * as React from 'react';
import { Button, Card, Spin, } from 'antd';
import { Progress } from '@ant-design/plots'
import { L } from '../../../../lib/abpUtility';
import { LoadingOutlined, RightCircleOutlined, } from '@ant-design/icons';
import Meta from 'antd/lib/card/Meta';

export interface ITemplateSelectCardProps {
    defaultIcon: any;
    primaryColor: string;
    secondaryColor: string;
    id: number;
    title: string;
    subTitle: string;
    tinyReports: any;
    cardSelect(input: any): void;
    getProfileImage: (id: any) => any;
    profileImageID: any;
}

export interface ITemplateSelectCardState {
    optionsExpanded: boolean;
    isMobile: boolean;
    cellProgress: number;
    cellSize: number;
    currentProfileImage: string;
    actionHeight: string; 
}

export class TemplateSelectCard extends React.Component<ITemplateSelectCardProps, ITemplateSelectCardState> {

    state = {
        cellSize: 0,
        cellProgress: 1,
        optionsExpanded: false, 
        isMobile: false,
        actionHeight: '50px',
        currentProfileImage: '',
        
    };

    async componentDidMount() {
  
        let imageURL = await this.props.getProfileImage(this.props.profileImageID); 
        this.setState({ currentProfileImage: imageURL }); 
    }


    handleResize = () => {
        if (window.innerWidth >= 550) {
            this.setState({
                isMobile: false
            });
        }
        else {
            this.setState({
                isMobile: true
            });
        }


    }

    handleClickOutside = async () => {
        this.setState({ optionsExpanded: false });
    }

    handleOptionExpand = async () => {
        this.props.cardSelect(this.props.id);
    }

    render() {

        const headerConfig = {
            percent: this.state.cellProgress,
            color: [this.props.secondaryColor, this.props.primaryColor],
        };

      
        const antIcon = <LoadingOutlined style={{ fontSize: 20, color: this.props.primaryColor }} spin />;

        const defaultImage =
            this.state.currentProfileImage === '' || this.state.currentProfileImage === '_'
                ? this.state.currentProfileImage !== '_'
                    ? <Spin indicator={antIcon}  >{this.props.defaultIcon}</Spin>
                    : this.props.defaultIcon : <img style={{ width: '40px', height: '40px' }}
                        src={this.state.currentProfileImage} />
 

        return (
            <div>

                <div>
                    <Card className="font-face-gm" bodyStyle={{height: '100px'}} bordered={true}
                        hoverable={true} style={{ borderColor: '#e9eaec', borderWidth: '2px', }}

                        cover={
                            [this.state.isMobile === false ? (
                                <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                                    <Progress height={25} autoFit={true} style={{ marginTop: '-12px', width: '80%' }} {...headerConfig} /></div>
                            ) : null]}
                    >

                        {this.state.isMobile === true ? (
                            <div >


                                <Meta className="font-face-gm" title={<div style={{ fontSize: '1.5em', height: '30px', marginBottom: '-5px' }}>{this.props.title}</div>}
                                    avatar={defaultImage}
                                    description={this.props.subTitle} />

                                <div >
                                    {this.state.optionsExpanded === false ? (<div>
                                        <div>
                                            <div style={{ float: 'right', paddingTop: '10px' }}><Button className="font-face-gm" onClick={this.handleOptionExpand}
                                                style={{ minWidth: '75px', borderColor: this.props.primaryColor, color: this.props.primaryColor }} type="default">
                                                {L('Actions')}
                                            </Button></div>
                                        </div></div>) : (
                                        <div>

                                            <div style={{ float: 'right', paddingTop: '10px' }}>
                                                <Button className="font-face-gm" onClick={this.props.cardSelect} style={{ marginRight: '10px', minWidth: '50px', color: this.props.secondaryColor, borderColor: this.props.secondaryColor }} type="dashed">
                                                    {L('Select')}
                                                </Button>

                                                <Button className="font-face-gm" onClick={this.handleClickOutside} style={{ borderColor: this.props.secondaryColor }} type="default">
                                                    <RightCircleOutlined />
                                                </Button>
                                            </div>

                                        </div>)}
                                </div>


                            </div>
                        ) : (
                            <div style={{ height: '60px' }} >

                                <div>
                                    <div>
                                        <div style={{ float: 'right', }}><Button className="font-face-gm" 
                                        onClick={this.handleOptionExpand}
                                            style={{
                                                minWidth: '75px',
                                                borderColor: this.props.primaryColor,
                                                color: this.props.primaryColor
                                            }} type="default">
                                            {L('Select')}
                                        </Button></div></div>
                                </div>



                                <Meta className="font-face-gm" title={<div style={{ fontSize: '1.2em', paddingBottom: '-20px', marginBottom: '0px', marginTop: '-5px' }}>{this.props.title}</div>}
                                    avatar={defaultImage} description={<div style={{fontSize: '0.9em', marginTop: '-10px', lineHeight: '12px'}}>{this.props.subTitle}</div>}
                                  />
                            </div>
                        )}


                    </Card>
                </div>
            </div>
        );
    }
}

export default TemplateSelectCard;
